module.exports = __webpack_public_path__ + "static/img/jt.c268bab5.png";